import { Component, Input } from '@angular/core';
import { DeviceSettingsService } from '../../../library/device-settings.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { ControlService } from '../../../library/control.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
  selector: 'app-device-settings-microphone-selection',
  templateUrl: './device-settings-microphone-selection.component.html',
  styleUrls: ['./device-settings-microphone-selection.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'settings',
    },
  ],
})
export class DeviceSettingsMicrophoneSelectionComponent {
  @Input() deviceSettingsService: DeviceSettingsService | undefined;

  constructor(
    private amplitudeService: AmplitudeService,
    private controlService: ControlService
  ) {}

  ngOnDestroy(): void {
    if (this.deviceSettingsService) {
      this.deviceSettingsService.stopDeviceSettings(false);
    }
  }
  public sendAmplitudeSelectMicEvent(): void {
    // Sending the Event of Selecting Microphone
    this.amplitudeService.trackEvent(
      AmplitudeTrackingEvents.DEVICE_SETTINGS_CLICK_SELECT_MICROPHONE,
      {
        microphone_type: this.deviceSettingsService?.audioDeviceSelected,
        call_type: this.controlService?.callType,
      }
    );
  }

  public handleSelectMicClick(): void {
    this.sendAmplitudeSelectMicEvent();
    this.deviceSettingsService?.setAudioDevice();
  }
}
